




























export default {
    name: 'AcceptBursaryApplicationModal',

    props: {
        candidate: {
            type: Object,
            required: false,
        },

        job_application_uuid: {
            type: String,
            required: false,
            default: null,
        },
    },

    setup(props, { emit }) {
        const { $auth, $gtm, $store, $toast } = useNuxtApp();

        const loading = ref<boolean>(false);

        const form = reactive({
            qualification: null,
            experience: null,
            other_factors: null,
        });

        const job = computed(() => $store.getters['jobs/single/getSingleJob']);
        const experiences = computed(() => props.candidate.work_experiences.map((item) => item.job_title));
        const qualifications = computed(() =>
            props.candidate.qualifications.map((item) => item.degree?.name || item.qualification_name).filter(Boolean),
        );

        const close = () => {
            emit('close-modal');
        };

        const recordEvent = (job_offer_uuid) => {
            $gtm.push({
                event: 'jobOfferSent',
                user_id: $auth.user.uuid,
                company_id: $auth.user.company.uuid,
                candidate_id: props.candidate.uuid,
                job_id: job.value.uuid,
                job_offer_id: job_offer_uuid,
            });
        };

        const submit = () => {
            loading.value = true;

            $store
                .dispatch('offerModule/acceptBursaryApplication', {
                    job_application_uuid: props.job_application_uuid,
                    candidate_uuid: props.candidate.uuid,
                    candidate_name: props.candidate.name,
                    candidate_profile: props.candidate,
                    deciding_factors: form,
                    job_uuid: job.value.uuid,
                })
                .then((res) => {
                    $toast.success('A notification has been sent to applicant.');
                    recordEvent(res.uuid);
                    close();
                })
                .catch((err) => {
                    $toast.danger(err.response.data.message);
                })
                .finally(() => {
                    loading.value = false;
                });
        };

        return {
            close,
            experiences,
            form,
            loading,
            submit,
            qualifications,
        };
    },
};
